export const getFirstInitialLastName = (name: string) => {
    // Create an array containing each of the words in the name
    var names = name.split(/\s+/);

    // Replaces the first name with an initial, followed by a period.
    names[0] = names[0].substring(0, 1) + ".";

    // Glue the pieces back together.
    return names.join(' ');
}

export const numberWithCommas = (x: number) => {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}